import React, { useState, useEffect } from "react";
import {
  FaBell,
  FaCalendarAlt,
  FaUsers,
  FaPlayCircle,
  FaShareAlt,
  FaLock,
  FaChartBar,
  FaCog,
  FaSlidersH,
  FaUser,
  FaUserPlus,
  FaHandsHelping,
  FaProjectDiagram,
  FaHandPointUp,
  FaRobot,
  FaArchive, 
  FaKey,
  FaShieldAlt,
  FaExclamationTriangle,
  FaDownload,
  FaChartLine,
  FaCalendarCheck,
} from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; 
import { useNavigate } from "react-router-dom";
import NotificationSetting from "../compo/NotificationSetting";
import CalanderSetting from "../compo/CalanderSetting";
import AutomationSetting from "../compo/AutomationSetting";
import SecuritySetting from "../compo/SecuritySetting";
import ReportSetting from "../compo/ReportSetting";


export default function SettingView() {
  const [currentView, setCurrentView] = useState("closed");
  const [selectedDate, setSelectedDate] = useState(new Date());


   const navigate = useNavigate();
    const [darkMode, setDarkMode] = useState(false);
     useEffect(() => {
       const adminId = localStorage.getItem("adminID");
       if (!adminId) {
         navigate("/"); 
       }
   
       // 👇 load dark mode preference
       const savedTheme = localStorage.getItem("darkMode") === "true";
       setDarkMode(savedTheme);
       document.body.classList.toggle("dark", savedTheme);
     }, [navigate]);





  const handleBackToMain = () => setCurrentView("main");

  const menuItems = [
    { icon: <FaBell />, label: "Notifications & Alerts", onClick: () => setCurrentView("notifications") },
    { icon: <FaCalendarAlt />, label: "Calendar & Time Settings", onClick: () => setCurrentView("calendar") },
    { icon: <FaUsers />, label: "Permissions & Access", onClick: () => setCurrentView("permissions") },
    { icon: <FaPlayCircle />, label: "Automation Settings", onClick: () => setCurrentView("automation") },
    { icon: <FaLock />, label: "Security Settings", onClick: () => setCurrentView("security") },
    { icon: <FaChartBar />, label: "Metrics & Reporting", onClick: () => setCurrentView("metrics") },
  ];


  const renderContent = () => {
    switch (currentView) {
      case "notifications":
        return (
          <div className={`settings-content pcard ${darkMode ? "dark" : ""}`}>
            
            <NotificationSetting/>
             
            <div className="back-link" onClick={handleBackToMain}>Back</div>
          </div>
        );

      case "calendar":
        return (
          <div className={`settings-content calendar-view-options pcard ${darkMode ? "dark" : ""}`}>
            <CalanderSetting/>
            <div className="back-link" onClick={handleBackToMain}>Back</div>
          </div>
        );

      case "permissions":
        return (
          <div className={`settings-content pcard ${darkMode ? "dark" : ""}`}>
            <div className="settings-header">
              <h3>Permissions & Access</h3>
            </div>
            <div className="settings-menu">
              <div className="settings-menu-item">
                <div className="menu-icon"><FaUser /></div>
                <div className="menu-label">User Roles</div>
                <div className="menu-arrow">›</div>
              </div>
              <div className="settings-menu-item">
                <div className="menu-icon"><FaUserPlus /></div>
                <div className="menu-label">Invitation Settings</div>
                <div className="menu-arrow">›</div>
              </div>
              <div className="settings-menu-item">
                <div className="menu-icon"><FaHandPointUp /></div>
                <div className="menu-label">Request Access</div>
                <div className="menu-arrow">›</div>
              </div>
              <div className="settings-menu-item">
                <div className="menu-icon"><FaProjectDiagram /></div>
                <div className="menu-label">Project & Folder Permissions</div>
                <div className="menu-arrow">›</div>
              </div>
              <div className="settings-menu-item">
                <div className="menu-icon"><FaHandsHelping /></div>
                <div className="menu-label">Collaboration Settings</div>
                <div className="menu-arrow">›</div>
              </div>
            </div>
            <div className="back-link" onClick={handleBackToMain}>Back</div>
          </div>
        );

      case "automation":
        return (
          <div className={`settings-content pcard ${darkMode ? "dark" : ""}`}>
            
            <AutomationSetting/>
            <div className="back-link" onClick={handleBackToMain}>Back</div>
          </div>
        );

     

      case "security":
        return (
          <div className={`settings-content pcard ${darkMode ? "dark" : ""}`}>
            <SecuritySetting/>
            <div className="back-link" onClick={handleBackToMain}>Back</div>
          </div>
        );

      case "metrics":
        return (
          <div className={`settings-content pcard ${darkMode ? "dark" : ""}`}>
            <ReportSetting/>
            <div className="back-link" onClick={handleBackToMain}>Back</div>
          </div>
        );

      case "main":
      default:
        return (
          <div className={`settings-content pcard ${darkMode ? "dark" : ""}`}>
            <div className="settings-header">
              <h3>Settings</h3>
            </div>
            <div className="settings-menu">
              {menuItems.map((item, index) => (
                <div key={index} className="settings-menu-item" onClick={item.onClick}>
                  <div className="menu-icon">{item.icon}</div>
                  <div className="menu-label">{item.label}</div>
                  <div className="menu-arrow">›</div>
                </div>
              ))}
              <div 
            //   className="close-settings" 
              className={`close-settings mainttl ${darkMode ? "dark" : ""} m-2`}
              
              onClick={() => setCurrentView("closed")}>
                Close Settings
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <>
      <button className="btn btn-light mb-3" onClick={() => setCurrentView("main")}>
        <FaCog size={20} />
      </button>

      {currentView !== "closed" && (
        <div className="settings-popup-overlay" >
          <div className={`settings-popup crdf2 ${darkMode ? "dark" : ""}`}>{renderContent()}</div>
        </div>
      )}
    </>
  );
}